import { render } from "./afterMovies.vue?vue&type=template&id=0d29c647"
import script from "./afterMovies.vue?vue&type=script&lang=js"
export * from "./afterMovies.vue?vue&type=script&lang=js"

import "./afterMovies.vue?vue&type=style&index=0&id=0d29c647&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__